import { useFontCollectionReferences } from "./useFontCollectionReferences";

export const useFontCollectionReferencesCount = (fontCollectionId: string) => {
  const { data: fontCollectionReferences } =
    useFontCollectionReferences(fontCollectionId);

  const totalDesignMappings =
    fontCollectionReferences?.global_mapping_list?.length || 0;

  const totalInputFormats = fontCollectionReferences?.format_list?.length || 0;

  return {
    total: totalDesignMappings + totalInputFormats,
  };
};
